import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

const Layout = () => {
  return (
    <>
      <Header />
      <Box sx={{ 
        mt: { 
          xs: '116px', // 36px (topbar) + 80px (header)
          sm: '116px' 
        }
      }}>
        <Outlet />
      </Box>
      <Footer />
    </>
  );
};

export default Layout;
